import '@zebra-fed/icons/Enterprise/index.css';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router";
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { DataContext } from '../../../data/DataContext';
import { AuthContext } from '../../../authentication/Auth';
import { ContentWrapper, Center } from '../../../styled-components/shared';
import { useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress";


import { summaryConfig } from "../../../data/dashboardConfig"
import firebaseUtil from '../../../data/FirebaseUtil';
import SummaryCountServices from '../../../Services/SummaryCountServices';
import config from "../../../data/application.properties";
const axiosInstance =  require("../../..//axios/axios").default;


const HeadContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
`

const TileContainer = styled.div`
  display: flex;
  flex-warp: wrap;
  flex-direction: column;
  padding: 8px;
`;

const StatusContainer = styled.div`
  min-width: 110px;
  width:${props => props.containerWidth};
  height:${props => props.containerHeight};
  background: ${props => props.bg};
  border-bottom: ${(props) => props.highlightSelected};
  text-align: center;
  margin-bottom: 2px;
  cursor: ${props => props.addCursor}
`;

const NoMarginP = styled.span`
    width:100%;
    text-align:center;
    font-size: ${props => props.fontSize};
    color: black;
`;

const CountValue = styled.span`
  margin: 0;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: ${props => props.fontSize};
  color: ${props => props.fontColor};
  line-height: 55px;
`;

const ContainerTitle = styled.div`
    margin-bottom: 15px;
    font-size: 20px;
`;


export default function SummaryContainer(props) {
  const history = useHistory();
  const { sitevalue, containerOf, fromWhere, loading } = props;
  const context = useContext(AuthContext);
  // DLR flag
  const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext)
  const { t } = useTranslation();
  const [computedArray, setComputedArray] = useState([]);
  const [countLength, setCountLength] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  // to highlight the title when its selected
  const { selectedTitle, setTitle } = props;
  const [isLoading, setIsLoading] = useState(loading);
  const location = useLocation();
  let companyID = context.currentUser.claims.companyID;

  const [RDValue, setRDValue] = useState('d');

  useEffect(() => {
    if (RDValue != 'd') {
      if (props.sitevalue == RDValue.site) {
        onDataChange(RDValue.value)
      }
      setRDValue('d')
    }
  }, [RDValue])


  useEffect(() => {
    getSummaryData();
  }, [sitevalue])

  /* uses RTDB Websockets commented Rob Galvin Apr 26
  useEffect(() => {
    SummaryCountServices.getAll(sitevalue, companyID).on('value', (snapshot) => {
      setRDValue({ value: snapshot.val(), site: sitevalue })
    });
    return () => {
      SummaryCountServices.getAll().off("value", (snapshot) => { onDataChange(snapshot.val()) });
    }
  }, [sitevalue])

  */

  useEffect(() => {
    if (localStorage) {
      localStorage.removeItem("firebase:previous_websocket_failure");
    }

    if(sessionStorage.getItem('selectedTile')){
      let deviceSearchObject = JSON.parse(sessionStorage.getItem('selectedTile'))
      setTitle(deviceSearchObject)
      history.push({
        pathname: location.pathname,
        state: {
          deviceSearchObject: deviceSearchObject,
          selectedSitevalue: sessionStorage.getItem("selectedSite") ? sessionStorage.getItem("selectedSite") : sitevalue
        }
      })
    }
    
  }, [])


  const getSummaryData = async () => {
    setIsLoading(true);
    firebaseUtil.getDeviceCountAxios({"siteName": sitevalue}).then(response => {
      console.log("Got REST Summary",response);
      setRDValue({ value: response.data, site: sitevalue })
      setIsLoading(false);
    }).catch(error => {
        console.log("getSummaryData Error: " + JSON.stringify(error))
        setIsLoading(false)
    })
  };

  function onDataChange(items) {
    setIsLoading(true)
    let summaryConfigArray = summaryConfig;
    let totaltrackedObj = {
      "dbKey": "totalTracked",
      "color": "#FFFFFF",
      "countColor": "#000000",
      "title": "Total",
      "filter": "totalTracked"
    }
    let summayCofigObject = summaryConfigArray[0].mobile.summaryDashboard;

    summayCofigObject["totalTracked"] = totaltrackedObj;

    const finalArray = [];
    const summayCofigObjectKeys = Object.keys(summayCofigObject)
    summayCofigObjectKeys.forEach((GH) => {
      if (items === null || items === undefined) {
        if (summayCofigObject[GH].filter === 'totalTracked') {
          finalArray.unshift({ ...summayCofigObject[GH], sumCount: 0 });
          return;
        }
        finalArray.push({ ...summayCofigObject[GH], sumCount: 0 })
      } else if (items[GH] != null) {
        if (summayCofigObject[GH].filter === 'totalTracked') {
          let sumCountIs = "" + items[GH];
          setCountLength(sumCountIs.length);
          finalArray.unshift({ ...summayCofigObject[GH], sumCount: items[GH] });
          return;
        }
        finalArray.push({ ...summayCofigObject[GH], sumCount: items[GH] })
      } else {
        if (summayCofigObject[GH].filter === 'totalTracked') {
          let sumCountIs = "" + items[GH];
          setCountLength(sumCountIs.length);
          finalArray.unshift({ ...summayCofigObject[GH], sumCount: 0 });
          return;
        }
        finalArray.push({ ...summayCofigObject[GH], sumCount: 0 })
      }
    })
    sessionStorage.setItem('summaryCountData', JSON.stringify(finalArray))
    props.getSummaryCount(finalArray)
    setIsLoading(false)
    setComputedArray([...finalArray]);
  }

  const tileClick = (idexIs, valueIs) => {
    sessionStorage.setItem('selectedTile', JSON.stringify(valueIs))
    if (computedArray[idexIs].sumCount > 0) {
      setTitle(valueIs);
      if (fromWhere === "devicesBoard") {
        history.push({
          pathname: `/dashboard/deviceslist/mobile-devices`,
          state: {
            deviceSearchObject: computedArray[idexIs],
            selectedSitevalue: sitevalue
          }
        })
      } else {
        sessionStorage.setItem('selectedSite', sitevalue)
        history.push({
          pathname: `/dashboard/deviceslist/mobile-devices`,
          state: {
            deviceSearchObject: computedArray[idexIs],
            selectedSitevalue: sitevalue
          }
        })
      }
    } else {
      console.log('Else-->', computedArray[idexIs])
    }
  }

  const widthBasedCountLength = () => {
    if (countLength <= 2) {
      return "110px"
    } else if (countLength <= 4) {
      return "130px"
    } else {
      return "160px"
    }
  }
  const StyledCircle = () => {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  };
  return (
    <>
      {isLoading && <StyledCircle />}
      <ContentWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1', position: 'relative' }}>
        {fromWhere !== "devicesBoard" ? <ContainerTitle>{containerOf + " " + t("devices")}</ContainerTitle> : null}
        <HeadContainer>
          {
            computedArray.length > 0 && computedArray?.map((valueIs, idx) => {
              // not showing atrisk tiles when DLR feature is off
              if((!dlrFeatureFlag || !mlPredictionStatus) && valueIs?.dbKey == "atRisk"){
                return null;
              }
              return (<TileContainer key={idx} >
                <StatusContainer addCursor={valueIs?.sumCount > 0 ? "pointer" : "default"} onClick={() => tileClick(idx, valueIs)} bg={valueIs?.color}
                  highlightSelected={
                    selectedTitle?.title === valueIs?.title
                      ? "8px solid #000000"
                      : ""
                  }
                  style={{
                    border: 'black solid 2px',
                    borderBottom: selectedTitle?.title === valueIs?.title
                      ? "8px solid #000000"
                      : 'black solid 2px'
                  }}

                  containerHeight={"60px"}
                  containerWidth={fromWhere === "devicesBoard" ? "100px" : widthBasedCountLength()} id={valueIs?.dbKey}>
                  <CountValue fontColor={valueIs?.countColor} fontSize={"20px"}>{valueIs?.sumCount}</CountValue>
                </StatusContainer>
                <NoMarginP fontSize={"12px"}>{valueIs?.title}</NoMarginP>
              </TileContainer>)
            })
          }
        </HeadContainer>
      </ContentWrapper>
    </>
  );
}